import React from "react";
import { Link } from "react-router-dom";
import { Wine } from "lucide-react";

export default function TastingCard({ t, ctaHref = "/kontakt?type=degustace#poptavka" }) {
  return (
    <article data-testid={`tasting-card-${t.slug}`} className="bg-cream border border-charcoal/10 p-8 flex flex-col hover:border-burgundy/40 transition-colors">
      <Wine size={22} className="text-burgundy" />
      <h3 className="mt-5 font-serif text-2xl text-charcoal">{t.name}</h3>
      <ul className="mt-4 space-y-1.5 text-sm text-charcoal/75">
        <li>{t.samples}</li>
        <li>{t.duration}</li>
      </ul>
      <div className="mt-6 pt-6 border-t border-charcoal/10">
        <div className="flex items-baseline gap-1">
          <span className="font-serif text-3xl text-burgundy">{t.price}</span>
          <span className="text-sm text-charcoal/70">Kč / osoba (sklep)</span>
        </div>
        {t.priceVineyard && (
          <div className="mt-1 text-xs text-charcoal/60">Ve&nbsp;vinohradě: {t.priceVineyard}&nbsp;Kč / osoba</div>
        )}
      </div>
      <Link
        to={ctaHref}
        data-testid={`tasting-cta-${t.slug}`}
        className="mt-6 bg-burgundy hover:bg-burgundy-hover text-ivory text-sm py-3 tracking-wide text-center"
      >
        Poptat degustaci
      </Link>
    </article>
  );
}
